import CheckInExtras from './CheckInExtras';

export default CheckInExtras;
